import ProductTemplate from "../../Biscuits-Template/Template";
import BisImg from "../../../assets/products/rectangle creams/rectangle chocolate biscuit.png";
import BiscuitImg from "../../../assets/products/rectangle creams/Rectangle-Chocolate.png";
import { Helmet } from "react-helmet-async";

const BiscuitData = [
  {
    grams: 27,
  },
  {
    grams: 40,
  },
  {
    grams: 50,
  },
  {
    grams: 75,
  },
  {
    grams: 80,
  },
];

export default function ChocolateRoundProduct() {
  return (
    <>
      <Helmet>
        <title>
          Rectangle Chocolate Cream Biscuit – BearBitz | Premium Biscuits &
          Cookies
        </title>
        <meta
          name="description"
          content="Explore BearBitz Rectangle Chocolate Cream Biscuits — rich, creamy chocolate-flavored sandwich biscuits. View pack sizes, cartons, and global specs."
        />
        <meta
          name="keywords"
          content="Rectangle Chocolate Cream Biscuit, BearBitz Chocolate Cream Biscuit"
        />
        <link
          rel="canonical"
          href="https://www.bearbitz.in/rectangle-cream-biscuit/rectangle-chocolate"
        />
        <meta
          property="og:title"
          content="Rectangle Chocolate Cream Biscuit – BearBitz"
        />
        <meta
          property="og:description"
          content="Cream-filled chocolate sandwich biscuit in rectangle shape with export-ready packaging."
        />
      </Helmet>

      <ProductTemplate
        productTitle="CHOCOLATE"
        productImage={BisImg}
        description="Sweet Layers of Joy.Crunchy biscuits filled with rich cream—classic favorites in every shape and flavor. A global snack sensation that delights with every bite."
        tableData={BiscuitData}
        BiscuitLogo={BiscuitImg}
        textColor="#683B1E"
        sectionBgColor="#FFC158"
        productBgcolor="#FFECCB"
        tableheadBgcolor="#683B1E"
        tableBgcolor="#FFECCB"
        footerBgcolor="#683B1E"
      />
    </>
  );
}
